import styled from '@emotion/styled'

import { colors, spacing, Text } from 'main/ui'

export const Container = styled.div`
  background-color: ${colors.background};
  padding: ${spacing.majorScale(3)}px;
`

export const SmallContainer = styled.div`
  margin: ${spacing.majorScale(3)}px 0;
`

export const ConfirmationContainer = styled.div`
  align-items: center;
  color: ${colors.text.active};
  display: flex;
  height: 55px;
  justify-content: center;

  ${Text} {
    color: ${colors.text.active};
    margin-left: ${spacing.majorScale(1)}px;
  }
`
